import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import { MastersComponent } from './masters.component';
import { AccountModule } from './accounts/accounts.module';
import { OperationalModule } from './operational/operational.module';
import { PeoplesModule } from './peoples/peoples.module';
import { DocumentModule } from '../document/document.module';
import { ChargesModule } from './charges/charges.module';
import { SystemConfigurationModule } from './system-configuration/system-configuration.module';

export const baseRoutes: Routes = [
      {
        path: 'accounts',
        loadChildren:() => AccountModule
      },
      {
        path: 'places',
        loadChildren:() =>import('./places/places.module').then(m=>m.PlacesModule)
      },
      {
        path: 'operational',
        loadChildren:() => OperationalModule
      },
      {
        path: 'peoples',
        loadChildren:() => PeoplesModule
      },
      {
        path: 'document',
        loadChildren:() => DocumentModule
      },
      {
        path: 'system-configuration',
        loadChildren: () => SystemConfigurationModule
      },
      {
        path: 'charges',
        loadChildren:() => ChargesModule
      },
      {
        path: 'crm',
        loadChildren:() => import('./crm/crm.module').then(m => m.CrmModule)
      }
];


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(baseRoutes),
  ],
  declarations: [MastersComponent]
})
export class MastersModule { }
